import { Box, Typography } from '@mui/material'
import { useAppTheme } from '@/theme/ThemeContext'
import NodeBox from './common/NodeBox'
import DatePicker from '@assets/flowchart/DatePicker.svg'
import NodeInput from './common/NodeInput'
import NodeCheckBox from './common/NodeCheckBox'
import NodeSelect from './common/NodeSelect'
import {
  IGNORE_MISSING_HINTS,
  IGNORE_MISSING_LABELS,
  ignoresMissingPeriods,
  STREAK_UNIT_OPTIONS,
  streakUnit,
  streakUnitPatch,
  type StreakUnit,
} from '@/alerts/hourlyAlert'
import { useNodeData } from './common/useNodeData'

// The engine reads neither field. The tree keeps both, so the save writes them back.
const STORED_WEEKDAY_NOTE =
  'העץ שומר סינון לפי ימים או שבת. המנוע כבר לא קורא אותו והוא נשמר כמו שהוא.'

const TimeNode = ({ id, data }: { id: string; data: any }) => {
  const patch = useNodeData(id)
  const unit = streakUnit(data ?? {})
  const { mode } = useAppTheme()
  const labelSx = {
    color: mode === 'dark' ? '#FFFFFF' : '#003F61',
    fontFamily: 'Rubik, sans-serif',
    fontSize: '14px',
    fontWeight: 300,
  }
  return (
    <NodeBox title="מאפיין זמן" icon={DatePicker} nodeId={id}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
        <Box
          sx={{
            display: 'flex',
            gap: 1,
            alignItems: 'center',
            justifyContent: 'flex-end',
          }}
        >
          <Typography sx={labelSx}>ברציפות</Typography>
          <NodeSelect
            placeholder="יחידה"
            options={STREAK_UNIT_OPTIONS}
            value={unit}
            onChangeValue={v => v && patch(streakUnitPatch(v as StreakUnit))}
          />
          <NodeInput
            value={data?.value ?? ''}
            onChange={v => patch({ value: v })}
          />
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
          }}
        >
          <NodeCheckBox
            text={IGNORE_MISSING_LABELS[unit]}
            checked={ignoresMissingPeriods(data ?? {})}
            onChange={e => patch({ ignoreMissingPeriods: e.target.checked })}
          />
          <Typography
            sx={{
              ...labelSx,
              fontSize: '12px',
              lineHeight: 1.3,
              marginTop: -1,
              opacity: 0.7,
            }}
          >
            {IGNORE_MISSING_HINTS[unit]}
          </Typography>
        </Box>
        {(data?.kept?.consider_days !== undefined ||
          data?.kept?.consider_shabbat !== undefined) && (
          <Typography
            sx={{ ...labelSx, fontSize: '12px', lineHeight: 1.3, opacity: 0.7 }}
          >
            {STORED_WEEKDAY_NOTE}
          </Typography>
        )}
      </Box>
    </NodeBox>
  )
}

export default TimeNode
